import type {CSSProperties} from 'react';
import {WEDGE_SUBSCRIPTION as S} from '@territory/tokens';
import {radius} from '../scale.js';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeSubscriptionLook = 'subscription-hero';

const SUBSCRIPTION_LOOKS = new Set<string>(['subscription-hero']);
export const isWedgeSubscriptionLook = (look: string): look is WedgeSubscriptionLook => SUBSCRIPTION_LOOKS.has(look);

/* Released Subscription screen, hero upgrade button (a free rep sees it above the plan list): a full-width flex block with a 16px
   radius, 16px by 18px padding and a 14px gap, on the 135 degree gradient from the accent to the dark accent, with the fixed white ink,
   no border and the green lift under it. It fades the transform and the shadow over 200ms on the Wedge ease. Each reads the exact
   legacy roles, in the declaration order of the source. The caller owns the frosted tile, the two lines of text and the chevron.
   The look draws no transparent target, anchor or stacking context (`wedgeSettingsDrawsHit`, and a `content: none` rule): the
   button is as wide as the screen and at least 76px tall (the 44px tile and the padding twice), so a 44px region could only repeat the
   box and would square its 16px corners. */
const PADDING = '16px 18px', GAP = 14, FADE_MS = 200, ANGLE = 135;

export function wedgeSubscriptionStyle(): CSSProperties {
  const r = wedgeExactRole;
  return {
    width: '100%', padding: PADDING, borderRadius: radius.card,
    background: `linear-gradient(${ANGLE}deg, ${r('accent')} 0%, ${r('accentDark')} 100%)`,
    color: S.ink, border: 0, cursor: 'pointer', fontFamily: r('font'),
    boxShadow: S.heroShadow,
    display: 'flex', alignItems: 'center', gap: GAP,
    transition: `transform ${FADE_MS}ms ${r('ease')}, box-shadow ${FADE_MS}ms ${r('ease')}`,
  };
}
